class CtaCarouselOverlay extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-35%',
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this)

    this.setMaxHeights()
  }

  setMaxHeights () {
    if (!this.els?.text?.selector) return

    this.els.slide.elements.forEach(slideEl => {
      const textEl = slideEl.querySelector(this.els?.text?.selector)

      if (textEl) {
        const animationSpeed = Math.round((textEl.offsetHeight / 300) * 10) / 10

        slideEl.style.setProperty('--Max_Height', `${textEl.offsetHeight}px`)
        slideEl.style.setProperty('--Animation_Speed', `${animationSpeed}s`)
      }
    })
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.3,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.4,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3.1,
              spacing: 30,
            },
          },
        },
        created: this.onSlideChanged,
        slideChanged: this.onSlideChanged,
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })

    this.setMaxHeights()
  }

  onEntry ([entry], observer) {
    this.setAttribute('active', entry.isIntersecting)
  }
}

if (!customElements.get('cta-carousel-overlay')) {
  customElements.define('cta-carousel-overlay', CtaCarouselOverlay)
}
